module.exports = __webpack_public_path__ + "img/logo.50fe9c40.png";